// src/api/workspace/index.js
import { http } from "../base"

/**
 * 获取租户的所有工作区列表
 * @param {number} tenantId - 租户ID
 * @returns {Promise} 响应结果
 */
export async function getWorkspaceListByTenant(tenantId) {
    console.log("getWorkspaceListByTenant 参数:", tenantId)
    try {
        const response = await http.get('/aics/kb_workspace/find_by_tenant', {
            params: { tenantId }
        })
        return response
    } catch (error) {
        return error
    }
}